import { observer } from "mobx-react";
import React, {useEffect, useState} from "react";
import {useTranslate} from "../../../../hooks/translate.hook";
import {useParams} from "react-router-dom";
import {AddressList} from "./address-list/address-list";
import {BranchAddress, BranchAddressRequestValues} from "../../../../models/branches/branch-data";
import {branchesService} from "../../../../services/branches/branches.service";
import {useRequiredStore} from "../../../../utils/store";
import {BranchDataStoreContext} from "../branch.data.store";
import {notifications} from "../../../../services/notifications/notifications";

export const BranchDataAddresses: React.FC = observer(() => {
    const { branchId } = useParams<{ branchId: string }>();
    const {branch} = useRequiredStore(BranchDataStoreContext);

    const [addresses, setAddresses] = useState<BranchAddress[]>([]);

    const [defaultId, setDefaultId] = useState<number>(branch?.defaultAddress.id || -1);

    const reload = async (branchId: string) => {
        setAddresses(await branchesService.getBranchesAddresses(branchId));
    }

    const create = async (values: BranchAddressRequestValues) => {
        await branchesService.createBranchesAddress(branchId!, values);
        notifications.successfully();
        await reload(branchId!);
    }

    const edit = async (values: BranchAddressRequestValues, item?: BranchAddress) => {
        await branchesService.updateBranchesAddress(item!.id, values);
        notifications.successfully();
        await reload(branchId!);
    }

    const remove = async (item: BranchAddress) => {
        await branchesService.removeBranchAddress(item!.id);
        notifications.successfully();
        await reload(branchId!);
    }

    const setDefault = async (item: BranchAddress) => {
        await branchesService.setDefaultAddress(item.id);
        setDefaultId(item.id);
        notifications.successfully();
        await reload(branchId!);
    }

    useEffect(() => {
        reload(branchId!);
    }, [branchId])

    return (
        <AddressList
            create={create}
            edit={edit}
            remove={remove}
            setDefault={setDefault}
            defaultId={defaultId}
            addresses={addresses}
        />
    );
});
